import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import {
	connectTeamsGlobalGroupsResource,
	routingOnboardingFinishedResource,
} from '@jira/router-resources__service-desk-routing/src/routingSetupStatusResource.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { isFeatureEnabled } from '@atlassiansox/frontend-feature-encoding';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { projectSettingsServicedeskWorkforceOptimizationRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskWorkforceOptimizationRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { WorkforceOptimizationSettingsSkeleton } from '@jira/spa-apps__project-settings-service-desk-workforce-optimization/src/WorkforceOptimizationSettingsSkeleton.tsx';
import { workforceRedirectEntryPoint } from '@jira/spa-apps__project-settings-service-desk-workforce-optimization/src/workforceRedirectEntryPoint.entrypoint.tsx';
import { expVal } from '@atlassian/jira-feature-experiments';
import { fg } from '@atlassian/jira-feature-gating';
import { workforceOptimizationSettingsPageEntryPoint } from './ui/service-desk-workforce-optimization/workforceOptimizationSettingsPageEntryPoint.tsx';

const isWorkforceAemEnabled = (): boolean =>
	fg('jsm_workforce_use_aem') ? isFeatureEnabled('jira-service-management', 'jsm-workforce') : true;

const getConnectTeamsGlobalGroupsResources = () =>
	expVal('global_group_search_wfo', 'isEnabled', false) ? [connectTeamsGlobalGroupsResource] : [];

const workforceRedirectPageEntryPoint = createPageEntryPoint({
	main: workforceRedirectEntryPoint,
});

export const projectSettingsServicedeskWorkforceOptimizationRouteEntry: ReturnType<
	typeof createEntry
> = createEntry(projectSettingsServicedeskWorkforceOptimizationRoute, () => ({
	group: 'project-settings-servicedesk',
	ufoName: 'jsm-workforce-optimization-settings',
	isRedirect: fg('jsm_workforce_settings_rename_route'),
	entryPoint: () => {
		if (fg('jsm_workforce_settings_rename_route')) {
			return workforceRedirectPageEntryPoint;
		}

		if (!isWorkforceAemEnabled()) {
			return undefined;
		}

		return workforceOptimizationSettingsPageEntryPoint;
	},
	layout: serviceProjectLayout,
	skeleton: fg('jsm-routing-release-2') ? WorkforceOptimizationSettingsSkeleton : undefined,

	navigation: {
		menuId: MenuIdProjects,
		sidebarId: SidebarIdProjectSettings,
	},

	resources: [
		...getServiceDeskSettingsResources(),
		getConsolidationStateResource(),
		routingOnboardingFinishedResource,
		...getConnectTeamsGlobalGroupsResources(),
	],
	forPaint: [LazyAtlassianNavigation],
	perfMetricKey: 'jsm-workforce-optimization-settings',

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
